import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperclip2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPaperclip2"><Path fillRule="evenodd" clipRule="evenodd" d="M11.5 5.25C11.5 3.45507 12.9551 2 14.75 2C16.5449 2 18 3.45507 18 5.25V16C18 19.3137 15.3137 22 12 22C8.68629 22 6 19.3137 6 16V8.5C6 8.22386 6.22386 8 6.5 8C6.77614 8 7 8.22386 7 8.5V16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16V5.25C17 4.00736 15.9926 3 14.75 3C13.5074 3 12.5 4.00736 12.5 5.25V15.5C12.5 15.7761 12.2761 16 12 16C11.7239 16 11.5 15.7761 11.5 15.5V5.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperclip2;
